import { styled } from "@mui/material/styles";

export const Container = styled("div")`
  display: flex;
  align-items: center;
  gap: 8px;
`;
